<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条库房出库</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" type="danger" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>
          <SelectFilter class="margin-left20" ref="selectFilter" :options="filterOptions" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="出库单号" width="180">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="outStockTypeName" label="出库方式" width="100"></el-table-column>
        <el-table-column prop="createdTime" label="出库日期" width="130">
          <template slot-scope="scope">
            <div>{{ parseTime(new Date(scope.row.date), "{y}-{m}-{d}") }}</div>
            <!-- <div>{{parseTime(new Date(scope.row.createdTime),'{h}:{i}:{s}')}}</div> -->
          </template>
        </el-table-column>
        <el-table-column prop="warehouseName" label="出库库房" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="claimDeptName" label="领用科室" width="100"></el-table-column>
        <el-table-column prop="dutyUserName" label="资产负责人" width="100"></el-table-column>
        <!-- <el-table-column prop="stateName" label="领用状态" width="100">
          <template slot-scope="scope">
            <span :class="getStatusClass(scope.row.state)">{{scope.row.stateName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="planStateName" label="计划状态" width="100"></el-table-column> -->
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>

        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames" />
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="
                scope.row.status == 1 &&
                  isShowApproveButton(scope.row.approverIds)
              " type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="
                scope.row.status != 1 && tableAcl.indexOf('Edit') != -1
              " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { RemoveWarehouseOutStocks, GetWarehouseOutStocks } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import SelectFilter from "@/components/table-select-filter";
import { WarehouseOutStockOptions } from "@/enum";
// import Info from './info';

export default {
  mixins: [GetDataMixin],
  components: {
    SelectFilter,
    // Info
  },
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      filterOptions: [
        {
          name: "出库方式",
          type: "select",
          code: "outStockType",
          data: WarehouseOutStockOptions,
        },
        {
          name: "关联单号",
          type: "select",
          code: "deptClaimNo",
          filterMethod: this.getDeptClaimsOn,
          showValue: "no",
          showMethod: {
            code: "outStockType",
            value: "0",
          },
          data: [],
        },
        {
          name: "关联单号",
          type: "select",
          code: "assetInStockNo",
          filterMethod: this.getAssetInStocks,
          showMethod: {
            code: "outStockType",
            value: "1",
          },
          data: [],
        },
        {
          name: "出库库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
        {
          name: "领用科室",
          type: "select",
          code: "claimDeptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "时间周期",
          type: "date",
          code: "date",
        },
      ],
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      GetWarehouseOutStocks(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 查看信息
    handleInfo (row) {
      this.$router.push("/warehouse-out-stock-edit?formMode=0&id=" + row.id);
    },
    // 新建
    handleAdd () {
      this.$router.push("/warehouse-out-stock-edit?formMode=1");
    },
    // 编辑
    handleUpdate (row) {
      this.$router.push("/warehouse-out-stock-edit?formMode=2&id=" + row.id);
    },
    // 审批
    handleApprove (row) {
      this.$router.push("/warehouse-out-stock-edit?formMode=3&id=" + row.id);
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveWarehouseOutStocks({ ids });
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
